<span class="title">{{title | translate}}</span>
<ng-content></ng-content>

